/* eslint-disable import/no-duplicates */
import FormSubmitButton from './FormSubmitButton';
import type FormHandler from './FormHandler';
import type { ValidationResult } from './ValidationService';
import { FormPostResult } from './IFormPostHandler';
import ControlGroup from './ControlGroup';
import type FormErrorMessenger from './FormErrorMessenger';
import ScreenReaderLoadingMessages from '../utils/screen-reader/ScreenReaderLoadingMessages';
import announce from '../utils/screen-reader/announce';
import type { FormHandlerOptions, FormHandlerSubmitCallback } from './FormHandler';

export default class FormSubmitHandler {
  isSubmitting = false;

  constructor(private formHandler: FormHandler, private options: FormHandlerOptions, private errorMessenger: FormErrorMessenger) {
  }

  startListening() {
    this.formHandler.$form.addEventListener('submit', this.onSubmit);
  }

  stopListening() {
    this.formHandler.$form.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event?: Event) => {
    if (event) {
      event.preventDefault();
    }

    this.submit(this.options.onValidationSuccess);
  };

  submit = async (onSubmit?: FormHandlerSubmitCallback) => {
    const { $submitBtn } = this.formHandler;

    if (this.isSubmitting || FormSubmitButton.isButtonDisbaled($submitBtn)) {
      return;
    }

    this.isSubmitting = true;

    FormSubmitButton.applyBusyStyling($submitBtn, { disableElement: false });

    announce(ScreenReaderLoadingMessages.Start);

    let response: FormPostResult;

    try {
      response = await this.formHandler.post();
    } catch (exception) {
      (this.options.onValidationAjaxException
        || (() => { window.location.href = '/error'; }))();

      return;
    }

    const { isValid } = response.validationResult;

    this.errorMessenger.clear();

    this.errorMessenger.processValidationResults(response.validationResult.validationResults, this.options.validationOptions);

    const stopSubmitting = () => {
      this.isSubmitting = false;
      FormSubmitButton.resetButtonStyling($submitBtn);
    };

    if (isValid) {
      if (onSubmit) {
        onSubmit({
          stopSubmitting,
          data: response.data,
        });
      } else {
        this.formHandler.$form.submit();
      }
    } else {
      stopSubmitting();
    }
  };
}
